<mat-radio-group
        class="radio-with-message__radio-group"
        id="{{fieldConfig.fieldKey}}"
        (change)="onChange($event)"
        (click)="onClick($event)"
        [formControl]="control">
    <ng-container *ngFor="let config of fieldConfig.radioConfig; let i = index">
        <div class="radio-with-message__radio-wrapper">
            <mat-radio-button id="{{fieldConfig.fieldKey + '-' + config.value}}"
                              class="radio-with-message__radio-button"
                              [checked]="config.value === bean"
                              [value]="config.value">
                <span class="radio-with-message__label">{{(config.label) | translate}} </span>
                <span *ngIf="!hasPriceConfig(config) && config.boldedLabel"
                      class="bold">
                    {{config.boldedLabel | translate}}
                    <ng-container *ngIf="config.currency">
                        {{config.currency | translate}}
                    </ng-container>
                </span>
                <span *ngIf="hasPriceConfig(config)" class="radio-with-message__price bold">
                    <span class="radio-with-message__price__main" [innerHTML]="config.mainPrice | safeHtml"></span>,<span class="radio-with-message__price__tails">{{ config.tailsPrice }}</span>&nbsp;<span *ngIf="config.currency">{{config.currency | translate}}</span>
                </span>
            </mat-radio-button>
            <span *ngIf="config.message && i > 0 && control.value === config.value"
                  class="radio-with-message__message-box">
                {{config.message | async | translate}}
                <ng-container *ngIf="config.currency">
                        {{config.currency | translate}}
                </ng-container>
            </span>
        </div>
    </ng-container>

    <mat-error *ngIf="errorsMap.get(fieldConfig.fieldKey)"
               class="radio-error">{{ (context + '.' + fieldConfig.fieldKey + '.' +
        errorsMap.get(fieldConfig.fieldKey))|translate}}
    </mat-error>
</mat-radio-group>
